import { render, staticRenderFns } from "./DashboardNewMembersSkeleton.vue?vue&type=template&id=43ae878c&scoped=true"
import script from "./DashboardNewMembersSkeleton.vue?vue&type=script&lang=js"
export * from "./DashboardNewMembersSkeleton.vue?vue&type=script&lang=js"
import style0 from "./DashboardNewMembersSkeleton.vue?vue&type=style&index=0&id=43ae878c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ae878c",
  null
  
)

export default component.exports